









import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import ImageMixin from '@/mixins/image';
import CookieMixin from '@/mixins/cookie';

@Component
export default class PlusButton extends mixins(ImageMixin, CookieMixin) {
  private fileName = 'estimate_icon_plus.png';
  @Prop({ default: false }) private disabled?: boolean;

  emitEvent(): void {
    this.$emit('increment');
  }
}
